/**
 * Wraps the leading currency symbol inside any ".price" element in its
 * own <span class="price__symbol">, so it can be styled independently
 * (e.g. smaller/italic) from the rest of the amount.
 *
 * Assumes each ".price" element's text is a simple string like "$22.00"
 * — a currency symbol (or code) followed directly by the number, with
 * no other markup mixed in. Runs once on load, then re-runs whenever
 * the theme swaps price markup back in (variant change, AJAX cart,
 * subscription frequency switch, etc.) via a MutationObserver, so it
 * doesn't need to be wired into every place that can update a price.
 */
(function () {
  function wrapSymbol(priceEl) {
    // Already processed — skip.
    if (priceEl.querySelector('.price__symbol')) return;

    // Only handle elements whose entire content is plain text (no
    // nested spans/icons) — anything more complex is left alone rather
    // than risking mangled markup.
    if (priceEl.childNodes.length !== 1 || priceEl.childNodes[0].nodeType !== Node.TEXT_NODE) return;

    var text = priceEl.textContent.trim();
    var match = text.match(/^(\D+)(.*)$/);
    if (!match) return;

    var symbol = match[1];
    var rest = match[2];

    priceEl.innerHTML = '<span class="price__symbol">' + symbol + '</span>' + rest;
  }

  function wrapAll(root) {
    (root || document).querySelectorAll('.price').forEach(wrapSymbol);
  }

  document.addEventListener('DOMContentLoaded', function () {
    wrapAll();

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          if (node.matches && node.matches('.price')) {
            wrapSymbol(node);
          } else if (node.querySelectorAll) {
            wrapAll(node);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
